/**
 * Short, factual tips rotated on the welcome screen. One is picked at random
 * each time the welcome state appears. Each tip should fit on a single line,
 * stay under ~110 characters, and read as a fact about Slate — never advice
 * about how to live your life.
 */
export const WELCOME_TIPS: readonly string[] = [
  'Cmd/Ctrl+K opens the command palette — start typing for files, slash for commands, # for headings.',
  'Cmd/Ctrl+/ opens the palette pre-seeded with /, so the command list is one keystroke away.',
  'Cmd/Ctrl+1, 2, 3 switch between Plain, WYSIWYG, and Rendered views without leaving the keyboard.',
  'Cmd/Ctrl+\\ toggles split view — the editor on the left, the rendered preview on the right.',
  'Type /zoom 1.6x in the palette to scale reading mode by a multiplier; bare numbers below 5 are multipliers too.',
  'Use /theme light, /theme dark, or /theme system to switch themes from anywhere.',
  '/open accepts a path: Tab autocompletes a segment, a trailing / descends one level.',
  'In /open, ~/ expands to your home folder, so ~/Documents/notes/ browses there directly.',
  'Drag a folder onto the window and Slate adds it as a workspace root automatically.',
  'Drag a file onto the editor and Slate drops a markdown link at the caret position.',
  'Mermaid diagrams and Vega-Lite charts render inline — click one to open it in a zoomable modal.',
  'Math is rendered with KaTeX. Inline $E = mc^2$ and display $$...$$ both work out of the box.',
  'Code blocks are syntax-highlighted with Shiki and stay readable in both light and dark themes.',
  'The outline panel lists every heading in the document — pin it, or let it overlay on hover.',
  'Click any heading in the outline to jump there in every visible pane at once.',
  'The active heading in the outline stays highlighted as you scroll, doubling as a position indicator.',
  'In split view, scroll either pane and the other follows — Slate picks the leader from your most recent action.',
  'Cmd/Ctrl+F opens find-in-document. Toggle case sensitivity and regex from the find bar.',
  'Opening a sidebar search result places the caret on the matched line, ready to type.',
  'Tables, Mermaid diagrams, and Vega charts show a Copy-as-markdown pill on hover in the rendered view.',
  'Tabs persist across launches — closing the app leaves your open files where you left them.',
  'Drop an image onto the editor and Slate saves it next to the document and links it for you.',
  'The palette caps mixed search at 100 results; matched file names appear before content matches.',
  'Press Esc to close the palette, the outline overlay, or any lightbox without touching the mouse.',
  'Autosave (when enabled) writes about 5 seconds after the last edit, so saves stay out of your way.',
];
